import { IEhrRecordsRepository } from "../../adapters/driven/repositories/ehrRecordsRepository";

export const EhrRecordsServiceImplFactory = ({
  ehrRecordsRepository,
}: {
  ehrRecordsRepository: IEhrRecordsRepository;
}) => {
  const getEhrMedications: IGetEhrMedicationsService = async (payload) => {
    try {
      const response = await ehrRecordsRepository.getEhrMedicationsAPI(payload);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getEhrNutrition: IGetEhrNutritionService = async (payload) => {
    try {
      const response = await ehrRecordsRepository.getEhrNutritionAPI(payload);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getEhrAssessments: IGetEhrAssessmentsService = async (payload) => {
    try {
      const response = await ehrRecordsRepository.getEhrAssessmentsAPI(payload);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getEhrAllergies: IGetEhrAllergiesService = async (payload) => {
    try {
      const response = await ehrRecordsRepository.getEhrAllergiesAPI(payload);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getEhrLabs: IGetEhrLabsService = async (payload) => {
    try {
      const response = await ehrRecordsRepository.getEhrLabsAPI(payload);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  return {
    getEhrMedications,
    getEhrNutrition,
    getEhrAssessments,
    getEhrAllergies,
    getEhrLabs,
  };
};
